/** Shared Tailwind classes for deep-link admin UI (light + dark). */

export const dlPageWrap =
  'flex min-h-[calc(100dvh-5.5rem)] flex-col overflow-hidden rounded-none border-0 bg-white sm:min-h-[480px] sm:rounded-xl sm:border sm:border-gray-200 dark:bg-gray-900 dark:sm:border-gray-700';

export const dlPageHeader =
  'shrink-0 border-b border-gray-200 bg-[#f8fafc] px-4 py-4 dark:border-gray-700 dark:bg-gray-900/80 sm:px-6';

export const dlPageBody = 'min-h-0 flex-1 overflow-y-auto p-4 sm:p-6';

export const dlInputClass =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:border-[#128C7E] focus:outline-none focus:ring-1 focus:ring-[#128C7E] dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500';

export const dlSelectClass = dlInputClass;

export const dlTextareaClass =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:border-[#128C7E] focus:outline-none focus:ring-1 focus:ring-[#128C7E] dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100';

export const dlLabelClass = 'mb-1 block font-medium text-gray-700 dark:text-gray-200';

export const dlSubLabelClass = 'mb-1 block text-gray-600 dark:text-gray-400';

export const dlCardClass =
  'rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800';

export const dlStatCardClass =
  'rounded-xl border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-800';

export const dlModalOverlayClass =
  'fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4';

export const dlModalPanelClass =
  'max-h-[95vh] w-full overflow-y-auto rounded-t-2xl border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-900 sm:max-h-[90vh] sm:rounded-xl';

export const dlModalPanelWideClass = `${dlModalPanelClass} lg:max-w-5xl`;

export const dlModalPanelViewClass = `${dlModalPanelClass} lg:max-w-4xl`;

export const dlModalHeaderClass =
  'flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700';

export const dlBtnPrimaryClass =
  'inline-flex items-center justify-center gap-2 rounded-lg bg-[#128C7E] px-4 py-2 text-sm font-medium text-white hover:bg-[#0f766e] disabled:opacity-60';

export const dlBtnSecondaryClass =
  'inline-flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700';

export const dlBtnGhostClass =
  'inline-flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700';

export const dlTableWrapClass =
  'overflow-x-auto rounded-xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800';

export const dlTableHeadClass =
  'bg-gray-50 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:bg-gray-800/80 dark:text-gray-400';

export const dlTableRowClass = 'border-t border-gray-100 dark:border-gray-700/80';

export const dlTableCellClass = 'px-4 py-3 text-sm text-gray-900 dark:text-gray-100';

export const dlMutedTextClass = 'text-sm text-gray-600 dark:text-gray-400';

export const dlHeadingClass = 'text-lg font-semibold text-gray-900 dark:text-white';

export const dlPlatformChipActive =
  'rounded-full border border-[#128C7E] bg-[#128C7E]/10 px-3 py-1 text-sm text-[#0f766e] dark:border-[#25D366] dark:bg-[#25D366]/10 dark:text-[#25D366]';

export const dlPlatformChipInactive =
  'rounded-full border border-gray-300 px-3 py-1 text-sm text-gray-600 dark:border-gray-600 dark:text-gray-400';

export const dlInfoBoxClass =
  'rounded-lg border border-[#128C7E]/20 bg-[#128C7E]/5 p-3 text-sm text-gray-700 break-all dark:border-[#25D366]/20 dark:bg-[#25D366]/5 dark:text-gray-200';

export const dlSectionBoxClass =
  'rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800/60';

export const dlCampaignCardClass =
  'rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 md:hidden';

export const dlTabBarClass =
  'flex gap-1 overflow-x-auto border-b border-gray-200 bg-[#f0f2f5] px-2 dark:border-gray-700 dark:bg-[#202c33] [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden';

export const dlTabButtonClass = (active: boolean) =>
  `inline-flex shrink-0 items-center gap-2 border-b-2 px-3 py-3 text-sm font-medium transition-colors sm:px-4 ${
    active
      ? 'border-[#128C7E] text-[#128C7E] dark:border-[#25D366] dark:text-[#25D366]'
      : 'border-transparent text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100'
  }`;
